import React from 'react'
import { onKeyboardSubmit } from '@app/helpers'
import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons'
import { Stack, Tooltip } from '@mui/material'
import { AnswerMaskButton, AnswerMaskIcon, AnswerMaskOverlay } from './styles'

interface Props {
  isMasked: boolean
  isEnabled: boolean
  toggle: () => void
  letterIndex?: string
  posInSet?: number
  children: (answerMaskingOverlay?: React.ReactNode) => React.ReactNode
}

const ChoiceAnswerMaskingContainer: React.FC<Props> = ({
  isMasked,
  isEnabled,
  toggle,
  letterIndex,
  posInSet,
  children,
}) => {
  if (!isEnabled) {
    return <>{children(null)}</>
  }

  // a11y: name each control by its answer so a screen reader doesn't read a run of identical "Mask Option"s;
  // the name stays stable and aria-checked conveys the masked state.
  // Multi-select choices carry no letter index, so fall back to position — otherwise every
  // toggle is named "Mask Option" and a screen reader reads a run of identical controls.
  const answerName = letterIndex ? `answer ${letterIndex}` : posInSet ? `answer ${posInSet}` : 'Option'

  return (
    <Stack direction='row' tabIndex={-1}>
      {children(isMasked ? <AnswerMaskOverlay /> : null)}

      <Tooltip title={`${isMasked ? 'Unmask' : 'Mask'} ${answerName}`}>
        <AnswerMaskButton
          onClick={toggle}
          onKeyDown={onKeyboardSubmit(toggle)}
          role="checkbox"
          aria-checked={isMasked}
          aria-label={`Mask ${answerName}`}
        >
          <AnswerMaskIcon icon={isMasked ? faEyeSlash : faEye} aria-hidden='true' focusable={false} />
        </AnswerMaskButton>
      </Tooltip>
    </Stack>
  )
}

export default ChoiceAnswerMaskingContainer
